module.exports = __webpack_public_path__ + "static/img/fct-2.2bae2b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/fct-2.png
// module id = dbfc
// module chunks = 63